


























































import Vue, { PropType } from 'vue'
import UiIcon from '../../UiIcon'
import { ProductItem } from '../UiSeriesList.types'

export default Vue.extend({
  name: 'UiSeriesComparisonCart',
  components: {
    UiIcon
  },
  props: {
    selectedProducts: {
      type: Array as PropType<ProductItem[]>,
      default: () => []
    },
    link: {
      type: String,
      default: '/'
    },
    compareText: {
      type: String,
      default: ''
    }
  }
})
